import { registerSW } from "virtual:pwa-register";
import type { AppModel } from "./state/app";

/**
 * Service Worker：只缓存“应用外壳”（页面、脚本、样式、图标），让二次打开很快、断网也能打开。
 * 不缓存任何对话内容和接口数据（连接全部走加密隧道，本来也缓存不了）。
 * 发布新版本后提示“有新版本，点此刷新”。
 */
export function registerServiceWorker(app: AppModel): void {
  if (!("serviceWorker" in navigator)) return;
  const update = registerSW({
    onNeedRefresh() {
      app.offerUpdate(() => update(true));
    },
  });
  // 页面一直开着的时候也定期检查新版本（PWA 可能几天不关）
  setInterval(() => {
    navigator.serviceWorker.getRegistration().then((r) => r?.update()).catch(() => {});
  }, 30 * 60 * 1000);
}
